import React from 'react';
import { Shield } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import SiteLogo from '../../components/Layout/SiteLogo';

const NifLinkRequired: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="min-h-[100dvh] bg-slate-100 flex items-center justify-center p-4 sm:p-6">
      <div className="max-w-md w-full text-center bg-white rounded-2xl shadow-xl p-6 sm:p-8">
        <div className="flex justify-center mb-4">
          <SiteLogo size="md" className="justify-center" />
        </div>
        <Shield className="w-12 h-12 text-amber-500 mx-auto mb-4" />
        <h1 className="text-xl font-bold text-gray-900 mb-2">{t('nif.linkRequiredTitle')}</h1>
        <p className="text-gray-600 leading-relaxed">{t('nif.linkRequiredMsg')}</p>
      </div>
    </div>
  );
};

export default NifLinkRequired;
